import React from 'react'
import classNames from 'classnames'
import { get } from 'lodash'

const Textbox = ({
  className,
  handleChange,
  input,
  label,
  labelBottom,
  maxLength = null,
  minValue,
  readonly = false,
  required = false,
  textarea = false,
  type = 'text',
  wrapperClassName,
  ...props
}) => {
  const value = get(input, 'value', props.value)
  const positiveValue = value && Math.abs(value) >= 0 ? Math.abs(value) : null
  const onChange = get(input, 'onChange') || handleChange
  const { error } = props?.meta ?? ''

  let textInput = (
    <input
      className={classNames('textbox__input', className)}
      onChange={onChange}
      type={type}
      value={value}
      readOnly={readonly}
      required={required}
      maxLength={maxLength}
    />
  )

  if (label) {
    textInput = (
      <div className={classNames('textbox', wrapperClassName)}>
        <input
          className={classNames('textbox__input', className)}
          onChange={onChange}
          type={type}
          value={value}
          readOnly={readonly}
          required={required}
          maxLength={maxLength}
          placeholder='#'
        />
        <label className="textbox__label">{label}</label>
        {error && <span className='error'>{error}</span>}
      </div>
    )
  }

  if (textarea) {
    textInput = (
      <>
        <textarea
          className={classNames('textbox__input', '-textarea', className)}
          onChange={onChange}
          type={type}
          value={value}
          readOnly={readonly}
          rows='4'
          placeholder="#"
        />
        {label && <span className="textbox__label">{label}</span>}
        {labelBottom && <span className="textbox__label-bottom">{labelBottom}</span>}
      </>
    )
  }

  if (type === 'number') {
    textInput = (
      <div className={classNames('textbox', wrapperClassName)}>
        <input
          className={classNames('textbox__input', '-number-type', className)}
          maxLength={maxLength}
          min={minValue}
          onChange={onChange}
          placeholder='#'
          required={required}
          type={type}
          value={positiveValue}
        />
        <label className="textbox__label">{label}</label>
        {error && <span className='error'>{error}</span>}
      </div>
    )
  }

  return textInput
}

export default Textbox
